import React, { Component } from "react";
import ImageText from "../common/imageText";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { APPLICATION_CONTEXTS } from "../../constants";
import * as applicationActions from "../../actions/application";
import ImageBackground from "../common/imageBackground";

class Option extends Component {
  options = {
    temperature: require("./images/Popup_SetTemperature.png"),
    readingLight: require("./images/Popup_ReadingLight.png"),
    presets: require("./images/Popup_EnvironmentPresets.png"),
    bedShade: require("./images/Popup_BedShade.png"),
    allLights: require("./images/Popup_AllLights.png"),
    bedLight: require("./images/Popup_BedLight.png"),
    allShades: require("./images/Popup_AllShades.png"),
    solarShades: require("./images/Popup_SolarShade.png"),
    wallLight: require("./images/Popup_WallLight.png"),
  };

  constructor(props) {
    super(props);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
  }

  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  handleOnKeyUp(event) {
    if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      switch (event.key) {
        case "Enter":
          this.props.history.push("/environmental_controls");
          break;
        case "b":
          this.props.history.push("/environmental_controls");
          break;
        default:
      }
    }
  }

  handleClick() {
    this.props.history.push("/environmental_controls");
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/

  render() {
    const option = this.props.match.params.option;
    return (
      <div className="options">
        <ImageBackground id="background" />
        <ImageText id="text" src={this.options[option]} />
        <button
          className="menu-btn"
          onClick={() => this.handleClick()}
        ></button>
        <button
          className="back-btn"
          onClick={() => this.handleClick()}
        ></button>
      </div>
    );
  }
}

const ConnectedOption = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Option);

export default withRouter(ConnectedOption);
